import type { ReactNode } from 'react';
import { Card } from 'antd';

/** Oturumsuz sayfaların (giriş, şifremi unuttum, parola belirle) ortak çerçevesi. */
export function AuthKart({ altBaslik = 'Admin Panel', children }: { altBaslik?: string; children: ReactNode }) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f2f5',
      padding: 16,
    }}>
      <Card style={{ width: 400, maxWidth: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h1 style={{ margin: 0, color: '#1890ff' }}>RaporGör</h1>
          <p style={{ color: '#666' }}>{altBaslik}</p>
        </div>
        {children}
      </Card>
    </div>
  );
}
